import React, { useState } from "react";

export default function AadhaarInput({
  id,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  className = "", 
}) {
  const [realValue, setRealValue] = useState("");

  const handleChange = (e) => {
    let entered = e.target.value.replace(/ /g, "");
    let raw = realValue;

    if (entered.length > raw.length) {
      raw += entered.slice(raw.length);
    } else {
      raw = raw.slice(0, entered.length);
    }

    raw = raw.replace(/\D/g, "").slice(0, 12);
    setRealValue(raw);

    // Mask middle 4 digits
    let masked = raw
      .split("")
      .map((digit, i) => (i >= 4 && i < 8 ? "*" : digit))
      .join("")
      .replace(/(.{4})/g, "$1 ")
      .trim();

    // Send masked to parent
    onChange && onChange(masked, raw);

    // Show masked in input
    e.target.value = masked;
  };

  return (
    <div>
      <input
        type="text"
        id={id}
        disabled={disabled}
        placeholder="XXXX **** XXXX"
        // placeholder="Aadhar Number"
        inputMode="numeric"
        className={`form-control ${className}`} // Append passed className
        value={value || ""}
        // defaultValue=""
        onChange={handleChange}
        onBlur={onBlur}
      />
      {error && <span className="error">{error}</span>}
    </div>
  );
}
